var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessageIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.75016 15.0065C7.34064 15.8223 9.17023 16.0433 10.9092 15.6296C12.6482 15.2159 14.1823 14.1947 15.235 12.75C16.2876 11.3052 16.7897 9.53206 16.6506 7.74994C16.5116 5.96781 15.7406 4.29394 14.4767 3.02996C13.2127 1.76598 11.5388 0.995011 9.7567 0.855982C7.97457 0.716952 6.20139 1.21901 4.75668 2.27167C3.31197 3.32434 2.29074 4.85839 1.87702 6.59739C1.46329 8.3364 1.68428 10.166 2.50016 11.7565L0.833496 16.6731L5.75016 15.0065Z",
    stroke: "#00A884",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageIcon);
export default __webpack_public_path__ + "static/media/messageIcon.1a6e6c108698e19604825b14b18078e9.svg";
export { ForwardRef as ReactComponent };